import React from "react";
import styled from "styled-components";
import get from "lodash/get";
import dayjs from "dayjs";
import find from "lodash/find";

import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";

import DocumentsService from "../../services/DocumentsService";
import { DOCUMENT_TYPES } from "../../helpers/constants";
import { Typography } from "@mui/material";

const RelatedDocumentItem = ({
  document,
  preview,
  refetch,
  handleOpenEdit,
}) => {
  const formatDate = (date) => (date ? dayjs(date).format("DD/MM/YYYY") : "-");
  const docType = find(
    DOCUMENT_TYPES,
    (doc) => document.documentTypeId === doc.id
  );

  const deleteFile = async () => {
    try {
      await DocumentsService.deleteFile(get(document, "id"));
      !!refetch && refetch();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <StyleWrapper className="related-doc-list__item shadow-sm rounded-box d-flex justify-content-between align-items-center">
      <Stack
        flexDirection="row"
        alignItems="center"
        className="doc-title"
        flexShrink={0}
        maxWidth="100%"
      >
        <img src="/assets/icons/file-item.svg" />
        <span className="text-ellipsis">{get(document, "filename")}</span>
      </Stack>
      <Stack alignItems="flex-end">
        <Stack flexDirection="row" alignItems="center" gap={2}>
          {docType && (
            <span className="badge in-progress">{get(docType, ["name"])}</span>
          )}
          <span className="effective-date">
            {formatDate(get(document, "effectiveDate"))}
          </span>
          <Stack flexDirection="row" alignItems="center">
            <IconButton
              color="primary"
              variant="contained"
              onClick={() => preview(document)}
            >
              <img src="/assets/icons/eye.svg" />
            </IconButton>
            <IconButton
              className="edit-btn"
              onClick={() => handleOpenEdit(document)}
            >
              <img src="/assets/icons/edit.svg" />
            </IconButton>
            <IconButton className="more-btn" onClick={deleteFile}>
              <img src="/assets/icons/trash.svg" />
            </IconButton>
          </Stack>
        </Stack>
        <Typography color="var(--text-color)" fontSize={10}>
          Créé le {dayjs(document.createdAt).format("DD/MM/YYYY hh:mm")}
        </Typography>
      </Stack>
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  &.related-doc-list__item {
    padding: 0 15px;
    min-height: 73px;
    gap: 20px;
    border-radius: 6px;

    .doc-title {
      span {
        margin-left: 12px;
        font-size: 18px;
        font-weight: 700;
      }
    }

    .badge {
      color: var(--white);
      height: 23px;
      padding: 5px 10px;

      &.in-progress {
        background-color: var(--orange-light);
      }

      &.success {
        background-color: var(--green-color);
      }
    }

    .action-container {
      button:nth-child(2) {
        margin-left: 20px;
        flex-grow: 1;
      }
      .more-btn {
        width: 42px;
      }
    }

    .effective-date {
      width: 85px;
      text-align: center;
      color: var(--text-color);
      font-size: 14px;
      font-weight: 700;
    }
  }
`;

export default RelatedDocumentItem;
